import React from 'react';
import Modal from '../components/ui/Modal';
import { formatDateTime } from '../utils/format';

const NotificationModal = ({ isOpen, onClose, notification }) => {
  if (!notification) return null;

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={notification.title} size="md">
      <div className="text-sm text-gray-700 whitespace-pre-wrap break-words">{notification.content}</div>
      <p className="text-xs text-gray-500 mt-4">Published: {formatDateTime(notification.publishedDate)}</p>
    </Modal>
  );
};

export default NotificationModal;
